class TabGroup extends HTMLElement {
  constructor() {
    super();
    this.initLoad = true;
    this.currentTab = 0;
    this.$tabs = [...this.querySelectorAll('.tab-group__tab')];
    this.$tabpanels = [...this.querySelectorAll('.tab-group__tabpanel')];
    this.setupEventListeners();
    // Show first tab by default and do not focus
    this.showTab(0, false);
  }

  showTab(tabID = 0, focus = false) {
    this.currentTab = tabID;
    this.$tabpanels.forEach(($tabpanel, panelIndex) => {
      if (panelIndex === tabID) {
        $tabpanel.classList.remove('tab-group__tabpanel--is-hidden');
      } else {
        $tabpanel.classList.add('tab-group__tabpanel--is-hidden');
      }
    });
    this.$tabs.forEach(($tab, tabIndex) => {
      if (tabIndex === tabID) {
        $tab.setAttribute('aria-selected', true);
        $tab.removeAttribute('tabindex');
        $tab.classList.add('tab-group__tab--is-active');
        if (focus) $tab.focus();
      } else {
        $tab.setAttribute('aria-selected', false);
        $tab.classList.remove('tab-group__tab--is-active');
        // eslint-disable-next-line no-param-reassign
        $tab.tabIndex = -1;
      }
    });
  }

  showPreviousTab() {
    const tabCount = this.$tabs.length - 1;
    let targetTab = this.currentTab - 1;
    if (targetTab < 0) {
      targetTab = tabCount;
    }
    if (targetTab > tabCount) {
      targetTab = 0;
    }
    this.showTab(targetTab, true);
  }

  showNextTab() {
    const tabCount = this.$tabs.length - 1;
    let targetTab = this.currentTab + 1;
    if (targetTab < 0) {
      targetTab = tabCount;
    }
    if (targetTab > tabCount) {
      targetTab = 0;
    }
    this.showTab(targetTab, true);
  }

  setupEventListeners() {
    this.$tabs.forEach(($tab, tabIndex) => {
      $tab.addEventListener('keydown', (e) => this.keyboardEvents(e));
      $tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.showTab(tabIndex, true);
      });
    });
  }

  keyboardEvents(event) {
    switch (event.key) {
      case 'ArrowLeft':
        this.showPreviousTab();
        break;
      case 'ArrowRight':
        this.showNextTab();
        break;
      case 'Home':
        this.showTab(0, true);
        event.stopPropagation();
        event.preventDefault();
        break;
      case 'End':
        this.showTab(this.$tabs.length - 1, true);
        event.stopPropagation();
        event.preventDefault();
        break;
      default:
        break;
    }
  }
}

export default function init() {
  customElements.define('tab-group', TabGroup);
}
